import { createSlice } from "@reduxjs/toolkit";

export const atsDashboardSlice = createSlice({
  name: "atsdashboardslice",
  initialState: {
    loading: false,
    error: null,
    metrics: null,
    compareMetrics: null,
    roleBasedMetrics: null,
    metricsOverview: null,
    metricsGroup: null,
    reportToHierarchy: null,
    teamMetrics: null,
    compareTeamMetrics: null,
    teamRoleBasedMetrics: null,
    teamMetricsOverview: null,
    teamMetricsGroup: null,
    adminMetricsOverview: {
      raMetrics: null,
      bdmMetrics: null,
      recruiterMetrics: null
    },
    adminMetricsGroup: {
      raMetrics: null,
      bdmMetrics: null,
      recruiterMetrics: null
    },
    adminRAUsers: null,
    adminBDMUsers: null,
    adminRecruiterUsers: null,
    adminMetrics: null,
    adminCompareMetrics: null,
    treeHierarchy: [],
    treeHierarchyNodeWiseData : []
  },
  reducers: {
    // Loading
    setStateLoading(state) {
      state.loading = true;
    },
    revertStateLoading(state) {
      state.loading = false;
    },

    //common
    getMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.metrics = action.payload ?? {};
    },
    getMetricsFailure(state, action) {
      state.loading = false;
      state.error = "error";
    },
    getRoleBasedMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.roleBasedMetrics = action.payload ?? {};
    },
    getMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.metricsOverview = action.payload ?? {};
    },
    getMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.metricsGroup = action.payload ?? {};
    },
    setreportToHierarchy(state, action) {
      state.reportToHierarchy = action.payload ?? {};
    },
    getTeamMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.teamMetrics = action.payload ?? {};
    },
    getTeamRoleBasedMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.teamRoleBasedMetrics = action.payload ?? {};
    },
    getTeamMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.teamMetricsOverview = action.payload ?? {};
    },
    getTeamMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.teamMetricsGroup = action.payload ?? {};
    },
    getCompareMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.compareMetrics = action.payload ?? {};
    },
    getCompareTeamMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.compareTeamMetrics = action.payload ?? {};
    },

    //RA
    getRAMetricsStart(state) {
      state.loading = true;
    },
    getRARoleBasedMetricsStart(state) {
      state.loading = true;
    },
    getRAMetricsOverviewStart(state) {
      state.loading = true;
    },
    getRAMetricsGroupStart(state) {
      state.loading = true;
    },
    getRACompareMetricsStart(state, action) {
      state.loading = true;
    },

    //BDM
    getBDMMetricsStart(state) {
      state.loading = true;
    },
    getBDMRoleBasedMetricsStart(state) {
      state.loading = true;
    },
    getBDMMetricsOverviewStart(state) {
      state.loading = true;
    },
    getBDMMetricsGroupStart(state) {
      state.loading = true;
    },
    getBDMCompareMetricsStart(state, action) {
      state.loading = true;
    },

    //RECRUITWER
    getRecruiterMetricsStart(state) {
      state.loading = true;
    },
    getRecruiterRoleBasedMetricsStart(state) {
      state.loading = true;
    },
    getRecruiterMetricsOverviewStart(state) {
      state.loading = true;
    },
    getRecruiterMetricsGroupStart(state) {
      state.loading = true;
    },
    getRecruiterCompareMetricsStart(state, action) {
      state.loading = true;
    },

    //ADMIN
    getAdminRAMetricsOverviewStart(state) {
      state.loading = true;
    },
    getAdminBDMMetricsOverviewStart(state) {
      state.loading = true;
    },
    getAdminRecruiterMetricsOverviewStart(state) {
      state.loading = true;
    },
    getAdminRAMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsOverview.raMetrics = action.payload ?? {};
    },
    getAdminBDMMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsOverview.bdmMetrics = action.payload ?? {};
    },
    getAdminRecruiterMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsOverview.recruiterMetrics = action.payload ?? {};
    },
    getAdminRAMetricsGroupStart(state) {
      state.loading = true;
    },
    getAdminBDMMetricsGroupStart(state) {
      state.loading = true;
    },
    getAdminRecruiterMetricsGroupStart(state) {
      state.loading = true;
    },
    getAdminRAMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsGroup.raMetrics = action.payload ?? {};
    },
    getAdminBDMMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsGroup.bdmMetrics = action.payload ?? {};
    },
    getAdminRecruiterMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsGroup.recruiterMetrics = action.payload ?? {};
    },
    getAdminUsersStart(state, action) {
      state.loading = true;
    },
    setAdminRAUsers(state, action) {
      state.adminRAUsers = action.payload ?? {};
    },
    setAdminBDMUsers(state, action) {
      state.adminBDMUsers = action.payload ?? {};
    },
    setAdminRecruiterUsers(state, action) {
      state.adminRecruiterUsers = action.payload ?? {};
    },
    getAdminMetricsStart(state) {
      state.loading = true;
    },
    getAdminMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetrics = action.payload ?? {};
    },
    getAdminCompareMetricsStart(state) {
      state.loading = true;
    },
    getAdminCompareMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminCompareMetrics = action.payload ?? {};
    },
    getTreeHierarchyDataStart(state) {
      state.loading = true;
    },
    getTreeHierarchyDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.treeHierarchy = action.payload?.data;
    },
    getTreeHierarchyDataFailure(state) {
      state.loading = false;
    },
    getTreeHierarchyNodeDataStart(state) {
      state.loading = true;
    },
    getTreeHierarchyNodeDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.treeHierarchyNodeWiseData = action.payload?.data;
    },
    getTreeHierarchyNodeDataFailure(state) {
      state.loading = false;
    }
  },
});

export const {
  // Loading
  setStateLoading,
  revertStateLoading,

  //common
  getMetricsSuccess,
  getMetricsFailure,
  getRoleBasedMetricsSuccess,
  getMetricsOverviewSuccess,
  getMetricsGroupSuccess,
  setreportToHierarchy,
  getTeamMetricsSuccess,
  getTeamRoleBasedMetricsSuccess,
  getTeamMetricsOverviewSuccess,
  getTeamMetricsGroupSuccess,
  getCompareMetricsSuccess,
  getCompareTeamMetricsSuccess,

  //RA DASHBOARD
  getRAMetricsStart,
  getRAMetricsOverviewStart,
  getRAMetricsGroupStart,
  getRARoleBasedMetricsStart,
  getCompareMetricsStart,
  getRACompareMetricsStart,

  //BDM
  getBDMMetricsStart,
  getBDMRoleBasedMetricsStart,
  getBDMMetricsOverviewStart,
  getBDMMetricsGroupStart,
  getBDMCompareMetricsStart,

  //RECRUITER
  getRecruiterMetricsStart,
  getRecruiterRoleBasedMetricsStart,
  getRecruiterMetricsOverviewStart,
  getRecruiterMetricsGroupStart,
  getRecruiterCompareMetricsStart,

  //ADMIN
  getAdminRAMetricsOverviewStart,
  getAdminBDMMetricsOverviewStart,
  getAdminRecruiterMetricsOverviewStart,
  getAdminRAMetricsOverviewSuccess,
  getAdminBDMMetricsOverviewSuccess,
  getAdminRecruiterMetricsOverviewSuccess,
  getAdminRAMetricsGroupStart,
  getAdminBDMMetricsGroupStart,
  getAdminRecruiterMetricsGroupStart,
  getAdminRAMetricsGroupSuccess,
  getAdminBDMMetricsGroupSuccess,
  getAdminRecruiterMetricsGroupSuccess,
  getAdminUsersStart,
  setAdminRAUsers,
  setAdminBDMUsers,
  setAdminRecruiterUsers,
  getAdminMetricsStart,
  getAdminMetricsSuccess,
  getAdminCompareMetricsStart,
  getAdminCompareMetricsSuccess,
  getTreeHierarchyDataFailure,
  getTreeHierarchyDataSuccess,
  getTreeHierarchyDataStart,
  getTreeHierarchyNodeDataStart,
  getTreeHierarchyNodeDataSuccess,
  getTreeHierarchyNodeDataFailure

} = atsDashboardSlice.actions;

export default atsDashboardSlice.reducer;
